export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import(/* webpackChunkName: "root" */'@pages/Home.vue'),
    meta: {
      navColors: {
        navText: "dark-blue",
        navOptions: "deep-grey-green"
      }
    }
  },

  {
    name: 'referrals',
    path: '/referrals',
    component: () => import(/* webpackChunkName: "referrals" */'@pages/Referrals.vue'),
    meta: {
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      },
      hideNav: true
    }
  },

  // {
  //   name: 'services',
  //   path: '/services',
  //   component: () => import(/* webpackChunkName: "root" */'@pages/Services.vue'),
  //   meta: {
  //     navColors: {
  //       navText: "dark-blue",
  //       navOptions: "deep-grey-green"
  //     }
  //   }
  // },
  // {
  //   name: 'typography',
  //   path: '/typography',
  //   component: () => import(/* webpackChunkName: "root" */'@pages/Typography.vue'),
  //   meta: {
  //     navColors: {
  //       navText: "dark-blue",
  //       navOptions: "deep-grey-green"
  //     }
  //   }
  // },
]